<template>
    <div class="container" :style="containerStyleObj">
        <Row class="title-wrap" :style="titleWrapStyleObj" ref="titleWrap">
            <Col
                    :xs="{ span: 24 }"
                    :sm="{ span: 24 }"
                    :md="{ span: 24 }"
                    :lg="{ span: 24 }"
            >
            <div class="title" :style="titleStyleObj">
                <img src="../../assets/images/databoard/head-left-icon.png"/>
                <span v-on:click="handleFullScreen()">{{schoolData.school_name}}</span>
                <img src="../../assets/images/databoard/head-right-icon.png"/>
            </div>
            <div class="logo" :style="logoStyleObj">
                <img
                        src="../../assets/images/databoard/cloud-C30.png"
                        style="margin: 3.5px 0; width:110px;height:32px;"
                />
                <span class="split-line"></span>
                <img
                        src="../../assets/images/databoard/17_logo.png"
                        style="margin: 3.5px 0;width:99px;height:32px;"
                />
                <span class="split-line"></span>
                <img
                        src="../../assets/images/databoard/cloud-ai.png"
                        style="margin: 3.5px 0;width:140px;height:32px;"
                />
            </div>
            <div class="full-screen" v-on:click="handleFullScreen()">
                <template v-if="!fullscreen">
            <span class="full-icon"
            ><img src="../../assets/images/databoard/full-screen-icon.png"
            /></span>
                    <span class="full-title">全屏</span>
                </template>
                <template v-else>
            <span class="full-icon"
            ><img
                    src="../../assets/images/databoard/exit-full-screen-icon.png"
            /></span>
                    <span class="full-title">取消全屏</span>
                </template>
            </div>
            <div
                    class="statis-report"
                    v-on:click="gotoSchoolList()"
                    v-if="freeLoginOrigin != 'xcjyy'&&$route.query.origin!='chart'"
            >
                <span class="full-title">统计报表</span>
            </div>
            </Col>
        </Row>
        <Row :gutter="20" class="statistic-wrap" :style="statisticWrapStyleObj">
            <Col
                    :xs="{ span: 6 }"
                    :sm="{ span: 6 }"
                    :md="{ span: 6 }"
                    :lg="{ span: 6 }"
                    style="padding-right: 0px"
            >
            <!--校本书库统计-->
            <ebook-statis
                    :ebookCountList="ebookCountList"
                    :titleHeight="titleHeight"
                    :screenHeight="screenHeight"
            ></ebook-statis>
            <!--课件统计-->
            <courseware-statis
                    :teaCourseware="teaCourseware"
                    :teaCoursewareCount="teaCoursewareCount"
                    :titleHeight="titleHeight"
                    :screenHeight="screenHeight"
            ></courseware-statis>
            <!--教师课堂行为分析-->
            <tea-classroom-behavior
                    :teaClassBehavior="teaClassBehavior"
                    :titleHeight="titleHeight"
                    :screenHeight="screenHeight"
            ></tea-classroom-behavior>
            </Col>
            <Col
                    :xs="{ span: 12 }"
                    :sm="{ span: 12 }"
                    :md="{ span: 12 }"
                    :lg="{ span: 12 }"
            >
            <div class="statis-count" :style="statisCountStyleObj">
                <Col
                        :xs="{ span: 12 }"
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                >
                <div class="count-wrap" style="margin-right: 10px">
                    <ul>
                        <li v-on:click="lookSchoolStatisInfo('schoolClassList')">
                            <infor-card
                                    class="data-sur-count-card"
                                    style="cursor: pointer"
                                    :numStyleObj="numStyleObj"
                                    :nameStyleObj="nameStyleObj"
                                    :startDataVal="newSchoolData.use_class_num"
                                    :end-val="newSchoolData.class_num"
                                    intro-text="使用班级数/总数"
                                    cardType="newDataSupervise"
                                    :isConvert="isConvert"
                            ></infor-card>
                            <span class="right-border"></span>
                        </li>
                        <li v-on:click="lookSchoolStatisInfo('schoolTeacherList')">
                            <infor-card
                                    class="data-sur-count-card"
                                    style="cursor: pointer"
                                    :numStyleObj="numStyleObj"
                                    :nameStyleObj="nameStyleObj"
                                    :startDataVal="'70'"
                                    :end-val="newSchoolData.tea_num"
                                    intro-text="使用教师数/总数"
                                    cardType="newDataSupervise"
                                    :isConvert="isConvert"
                            ></infor-card>
                            <span class="right-border"></span>
                        </li>
                        <li v-on:click="lookSchoolStatisInfo('schoolStudentList')">
                            <infor-card
                                    class="data-sur-count-card"
                                    style="cursor: pointer"
                                    :numStyleObj="numStyleObj"
                                    :nameStyleObj="nameStyleObj"
                                    :startDataVal="'1430'"
                                    :end-val="newSchoolData.stu_num"
                                    intro-text="使用学生数/总数"
                                    cardType="newDataSupervise"
                                    :isConvert="isConvert"
                            ></infor-card>
                        </li>
                    </ul>
                </div>
                </Col>
                <Col
                        :xs="{ span: 12 }"
                        :sm="{ span: 12 }"
                        :md="{ span: 12 }"
                        :lg="{ span: 12 }"
                >
                <div class="count-wrap">
                    <ul>
                        <li>
                            <infor-card
                                    class="data-sur-count-card"
                                    :numStyleObj="numStyleObj"
                                    :nameStyleObj="nameStyleObj"
                                    :startDataVal="-1"
                                    :end-val="teaActTotalHwNum"
                                    intro-text="作业总数"
                                    cardType="newDataSupervise"
                                    :isConvert="isConvert"
                            ></infor-card>
                            <span class="right-border"></span>
                        </li>
                        <li v-on:click="lookStatisInfo('resource')">
                            <infor-card
                                    class="data-sur-count-card"
                                    style="cursor: pointer"
                                    :numStyleObj="numStyleObj"
                                    :nameStyleObj="nameStyleObj"
                                    :startDataVal="newSchoolData.rs_share_num"
                                    :end-val="newSchoolData.rs_upload_num"
                                    intro-text="分享/上传资源总数"
                                    cardType="newDataSupervise"
                                    :isConvert="isConvert"
                            ></infor-card>
                            <span class="right-border"></span>
                        </li>
                        <li v-on:click="lookStatisInfo('microClass')">
                            <infor-card
                                    class="data-sur-count-card"
                                    style="cursor: pointer"
                                    :numStyleObj="numStyleObj"
                                    :nameStyleObj="nameStyleObj"
                                    :startDataVal="newSchoolData.cw_share_num"
                                    :end-val="newSchoolData.cw_upload_num"
                                    intro-text="分享/上传微课总数"
                                    cardType="newDataSupervise"
                                    :isConvert="isConvert"
                            ></infor-card>
                        </li>
                    </ul>
                </div>
                </Col>
            </div>
            <!--教师操作动态-->
            <div class="tea-oper-dym" :style="teaOperDymStyleObj">
                <span class="border-left-top"></span>
                <span class="border-left-bottom"></span>
                <span class="border-right-top"></span>
                <span class="border-right-bottom"></span>
                <div class="statis-title bg1">
                    <span>教学动态</span>
                </div>
                <div class="dym-content" :style="dymContentStyleObj">
                    <tea-dynamic
                            :dynamicData="dynamicData"
                            @openPreview="openPreview"
                            @lookInterInfo="lookInterInfo"
                            ref="dynamicRef"
                    ></tea-dynamic>
                </div>
            </div>
            <pie-item
                    name="teaBehavior"
                    :titleHeight="titleHeight"
                    :paramTeaData="teaBehaviorData"
                    :paramStuData="stuBehaviorData"
                    :schoolName="schoolData.school_name"
                    :schoolId="schoolId"
                    :form="'school'"
                    :screenHeight="screenHeight"
            ></pie-item>
            </Col>
            <Col
                    :xs="{ span: 6 }"
                    :sm="{ span: 6 }"
                    :md="{ span: 6 }"
                    :lg="{ span: 6 }"
                    style="padding-left: 0"
            >
            <!--作业统计-->
            <cloud-homework-statis
                    ref="activeDetailStatis"
                    :evlPer="evlPer"
                    :titleHeight="titleHeight"
                    :screenHeight="screenHeight"
                    :schoolId="schoolId"
                    :schoolName="schoolData.school_name"
            >
            </cloud-homework-statis>
            <!--学科能力和知识掌握-->
            <subject-knowledge-ability
                    ref="activeDetailStatis"
                    :evlPer="evlPer"
                    :titleHeight="titleHeight"
                    :screenHeight="screenHeight"
                    :schoolId="schoolId"
                    :schoolName="schoolData.school_name"
            ></subject-knowledge-ability>

            <!--教师活跃情况-->
            <cloud-active-teacher-statis
                    ref="activeDetailStatis"
                    :evlPer="evlPer"
                    :titleHeight="titleHeight"
                    :screenHeight="screenHeight"
                    :schoolId="schoolId"
                    :schoolName="schoolData.school_name"
            ></cloud-active-teacher-statis>
            </Col>
        </Row>
        <!--课堂互动弹框-->
        <div v-show="isShowModal">
            <div class="mask-box"></div>
            <div class="panel-box">
                <div class="close-btn">
                    <img
                            class="logo-img"
                            src="../../assets/images/databoard/close_btn.png"
                            width="100%"
                            height="100%"
                            v-on:click="closeWin"
                    />
                </div>
                <div class="panel-main">
                    <div class="icon-box-wrap">
                        <img
                                class="icon-box"
                                :src="currentInter.evaluate_type_icon"
                                width="100%"
                                height="100%"
                                v-if="currentInter.evaluate_type_icon != ''"
                        />
                        <p class="icon-txt">{{ currentInter.evaluate_type_name }}</p>
                    </div>
                    <div class="info-box">
                        <p>
                            <span class="txt-item">{{ currentInter.school_name }}</span>
                            <span class="txt-item"
                            >{{ currentInter.teacher_real_name }}老师</span
                            >
                            对
                            <span class="txt-item">{{ currentInter.student_real_name }}</span>
                            学生
                        </p>
                        <p>进行了 “ {{ currentInter.evalContent }} ” 的评价</p>
                    </div>
                </div>
            </div>
        </div>
        <dt-preview-slider
                ref="previewSlider"
                :previewMode="previewMode"
                :previewVideoMode="previewVideoMode"
                :videoSrc="videoSrc"
                @closePreview="closePreview"
        ></dt-preview-slider>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import inforCard from "../../components/inforCard.vue"; //数据卡片
    import {findBoardTopData, findSchoolData, fetchBehaviorData, fetchHwData} from "../../service/bigDataApi.js";

    //校本书库统计
    import ebookStatis from "./modules/ebookStatis";
    //课堂评价分析
    import classroomEva from "./modules/classroomEva";
    //课堂行为分析
    import classroomInter from "./modules/classroomInter";
    //课件统计
    import coursewareStatis from "./modules/coursewareStatis";
    //作业统计
    import homeworkStatis from "./modules/homeworkStatis";
    //实时动态
    import teaDynamic from "./modules/teaDynamic.vue";
    //教师课堂行为分析
    import teaClassroomBehavior from "./modules/teaClassroomBehavior";
    //教师行为，学生行为
    import pieItem from "./modules/pieItem";

    import cloudActiveTeacherStatis from "./modules/cloudActiveTeacherStatis";
    import subjectKnowledgeAbility from "./modules/subjectKnowledgeAbility";
    import cloudHomeworkStatis from "./modules/cloudHomeworkStatis";


    export default {
        name: "school-index",
        components: {
            inforCard, //数据卡片
            ebookStatis,
            classroomEva,
            classroomInter,
            coursewareStatis,
            homeworkStatis,
            teaClassroomBehavior,
            teaDynamic,
            pieItem,
            subjectKnowledgeAbility,
            cloudActiveTeacherStatis,
            cloudHomeworkStatis
        },
        computed: {
            ...mapGetters(["freeLoginOrigin"]),
        },
        data() {
            return {
                isConvert: 1, //是否转换数字
                fullscreen: false,
                schoolData: {},
                newSchoolData: {},
                evlPer: 80,
                teaCourseware: [], //教师课件
                stuHomework: [], //学生作业
                teaClassBehavior: [], //教师课堂行为
                dynamicData: [], //实时动态
                baseData: [], //基础数据
                classInteractData: [], //课堂互动
                classInteractTotal: 0, //课堂互动总数
                teaBehaviorData: [], //教师行为
                stuBehaviorData: [], //学生行为
                ebookCountList: [], //校本书库
                top: [],
                left: [130, 140, 150, 160, 170, 180, 190, 200, 210, 230],
                color: ["#FFF", "#00d8ff", "#ffce23"],
                scrollInterval: {}, //动态滚动区间,
                scrollIngDynamicList: [],
                screenHeight: document.body.clientHeight, // 屏幕默认宽度
                containerStyleObj: {
                    height: "",
                },
                titleWrapStyleObj: {
                    height: "",
                },
                titleStyleObj: {
                    height: "",
                },
                logoStyleObj: {
                    height: "",
                },
                statisticWrapStyleObj: {
                    height: "",
                    margin: "0px 0px 10px 0px",
                },
                statisCountStyleObj: {
                    height: "",
                },
                numStyleObj: {
                    height: "",
                    lineHeight: "",
                },
                nameStyleObj: {
                    height: "",
                    lineHeight: "",
                },
                teaOperDymStyleObj: {
                    height: "",
                },
                dymContentStyleObj: {
                    height: "",
                },
                teaCoursewareCount: "", //教师课件总数
                titleHeight: 0,
                countWeight: 700,
                previewMode: false,
                previewVideoMode: false,
                videoSrc: "",
                isShowModal: false,
                currentInter: {},
                tabsName: "", //标签页名称
                schoolId: this.$route.params.schoolId, //学校id
                logoPath: process.env.VUE_APP_DASH_LOGO_PATH,
                yjtLogoPath: process.env.VUE_APP_DASH_YJT_LOGO_PATH,
                timestamp: new Date().getTime(),
                channel: process.env.VUE_APP_CHANNEL,
                teaActTotalHwNum: 0  //一起的作业总数
            };
        },
        created() {
        },
        watch: {},
        methods: {
            /**
             * 获取作业数据
             */
            async getHwData() {
                let _this = this;
                await fetchHwData()
                    .then(function (data) {
                        _this.teaActTotalHwNum = data.teaActTotalHwNum;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取数据展板所有统计数据
             */
            async findTeaBehaviorData() {
                let _this = this;
                // 学校ID，不传是平台的
                let params = {
                    schoolId: _this.schoolId == "0" ? "" : _this.schoolId,
                    phase: this.$store.getters.phase || '',
                };
                await findSchoolData(params)
                    .then(function (data) {
                        _this.schoolData = data;
                        //获取校本书库
                        _this.ebookCountList = JSON.parse(_this.schoolData.ebook_count_group);
                        //获取课件统计
                        _this.teaCourseware = JSON.parse(_this.schoolData.tea_courseware);
                        //获取课件总数
                        _this.teaCoursewareCount = _this.schoolData.courseware_count;
                        // if (_this.schoolData.stu_homework != "[]") {
                        _this.stuHomework = [
                            {
                                submitCount: 10683062,
                                bank_name: "英语",
                                allCount: 13165095,
                            },
                            {
                                submitCount: 10388504,
                                bank_name: "数学",
                                allCount: 12438786,
                            },
                            {
                                submitCount: 9392622,
                                bank_name: "语文",
                                allCount: 11218680,
                            },
                            {
                                submitCount: 4402700,
                                bank_name: "物理",
                                allCount: 5518509,
                            },
                            {
                                submitCount: 3577508,
                                bank_name: "生物",
                                allCount: 4315120,
                            },
                        ];
                        // }
                        // let stu_evaluate = JSON.parse(_this.schoolData.stu_evaluate);
                        // if (stu_evaluate.upCount == 0 || stu_evaluate.allCount == 0) {
                        //     _this.evlPer = 0;
                        // } else {
                        _this.evlPer = 91;
                        // }
                        //   //获取教师课堂行为分析
                        //   _this.teaClassBehavior = JSON.parse(
                        //     _this.schoolData.tea_class_behavior
                        //   );
                        _this.dynamicData = JSON.parse(data.dynamic);
                        // _this.baseData = JSON.parse(data.base_data);
                        //获取教师行为分析
                        _this.teaBehaviorData = JSON.parse(data.tea_behavior);
                        //获取学生行为分析
                        _this.stuBehaviorData = JSON.parse(data.stu_behavior);
                        _this.classInteractData = [
                            {
                                count: 33046,
                                displayCoding: "022",
                                displayName: "锁屏管理",
                            },
                            {
                                count: 156077,
                                displayCoding: "023",
                                displayName: "随机抢答",
                            },
                        ];
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取课堂行为分析
             */
            async getBehaviorData() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId == "0" ? "" : _this.schoolId,
                };
                await fetchBehaviorData(params)
                    .then(function (data) {
                        _this.teaClassBehavior = data;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });

            },
            /**
             * 获取数据展板所有统计数据
             */
            async getBoardTopData() {
                let _this = this;
                let params = {
                    schoolid: _this.schoolId == "0" ? "" : _this.schoolId,
                };
                await findBoardTopData(params)
                    .then(function (data) {
                        _this.newSchoolData = data;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 全屏
             */
            handleFullScreen() {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },
            /**
             * 查看学校列表
             */
            gotoSchoolList() {
                let _this = this;
                let routeData = this.$router.resolve({
                    name: "schoolList",
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 查看资源，作业，课堂评价等统计详情
             */
            lookStatisInfo(val) {
                let _this = this;
                let routeData = this.$router.resolve({
                    name: "schoolNewDataList",
                    params: {
                        schoolId:
                            this.schoolData.school_id === null
                                ? "0"
                                : this.schoolData.school_id,
                        schoolName: this.schoolData.school_name,
                        filtersName: "0",
                        classId: "0",
                        gradeId: "0",
                        subjectId: "0",
                        tabsName: val,
                        teaId: "0"
                    },
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 查看班级、教师、学生等统计详情
             */
            lookSchoolStatisInfo(name) {
                let _this = this;
                let routeData = this.$router.resolve({
                    name: name,
                    params: {
                        schoolId:
                            this.schoolData.school_id === null
                                ? "0"
                                : this.schoolData.school_id,
                        schoolName: this.schoolData.school_name,
                    },
                });
                window.open(routeData.href, "_blank");
            },

            /**
             * 预览资源
             */
            openPreview(resultUrl, count, type) {
                // type 0:其他 1.文档 2.视频 3.音频 4.图片
                if (type === 2) {
                    this.previewVideoMode = true;
                    this.videoSrc = resultUrl + "/video.mp4";
                    return;
                } else if (type === 3) {
                    this.$Message.error("音频文件，暂时无法预览！");
                    return;
                }
                if (!count) {
                    this.$Message.error("暂无缩略图，无法预览！");
                    return;
                }
                this.previewMode = true;
                this.$refs.previewSlider.swiperInit(resultUrl, count);
            },
            // 关闭预览
            closePreview(type) {
                this[type] = false;
                // //继续开始滚动
                // this.$refs.dynamicRef.hoverEvent();
                // this.$refs.dynamicRef.mouseleaveEvent();
            },
            /**
             * 查看互动详情
             */
            lookInterInfo(interObj) {
                this.isShowModal = true;
                this.currentInter = interObj;
                //互动评价
                this.currentInter.evalContent = this.currentInter.evaluate_type_name;
            },
            /**
             * 关闭弹窗
             */
            closeWin() {
                this.isShowModal = false;
                this.currentInter = {};
                // //继续开始滚动
                // this.$refs.dynamicRef.hoverEvent();
                // this.$refs.dynamicRef.mouseleaveEvent();
            },
        },
        mounted() {
            const _this = this;
            this.$nextTick(() => {
                let windowHeight = window.innerHeight;
                if (windowHeight < 900) {
                    windowHeight = 938;
                    document.getElementsByTagName("body")[0].className = "active";
                }
                let titleHeight = 128;
                let statisticHeight = windowHeight - titleHeight - 10;
                let statisHeight = windowHeight / 12.5;
                let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
                this.titleHeight = titleHeight;
                this.containerStyleObj.height = windowHeight + "px";
                this.titleWrapStyleObj.height = titleHeight + "px";
                this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
                this.logoStyleObj.height = titleHeight * 0.3 + "px";
                this.statisticWrapStyleObj.height = statisticHeight + "px";
                this.statisCountStyleObj.height = statisHeight + "px";
                this.numStyleObj.height = statisHeight * 0.6 + "px";
                this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
                this.nameStyleObj.height = statisHeight * 0.4 + "px";
                this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
                this.teaOperDymStyleObj.height = dymHeight + "px";
                this.dymContentStyleObj.height = dymHeight - 49 + "px";
                //获取数据展板所有统计数据
                this.findTeaBehaviorData();
                this.getHwData();
                this.getBoardTopData();
                this.getBehaviorData();
            });

            // 注：window.onresize只能在项目内触发1次
            window.onresize = function windowResize() {
                // 通过捕获系统的onresize事件触发我们需要执行的事件
                let windowHeight = document.body.clientHeight;
                if (windowHeight < 900) {
                    windowHeight = 938;
                    document.getElementsByTagName("body")[0].className = "active";
                }
                _this.screenHeight = windowHeight;
                let titleHeight = 128;
                let statisticHeight = windowHeight - titleHeight - 10;
                let statisHeight = windowHeight / 12.5;
                let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
                _this.titleHeight = titleHeight;
                _this.titleHeight = titleHeight;
                _this.containerStyleObj.height = windowHeight + "px";
                _this.titleWrapStyleObj.height = titleHeight + "px";
                _this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
                _this.logoStyleObj.height = titleHeight * 0.3 + "px";
                _this.statisticWrapStyleObj.height = statisticHeight + "px";
                _this.statisCountStyleObj.height = statisHeight + "px";
                _this.numStyleObj.height = statisHeight * 0.6 + "px";
                _this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
                _this.nameStyleObj.height = statisHeight * 0.4 + "px";
                _this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
                _this.teaOperDymStyleObj.height = dymHeight + "px";
                _this.dymContentStyleObj.height = dymHeight - 49 + "px";
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../style/databoard";
    @import "../../style/detailPage";

    .panel-box {
        background-image: url("../../assets/images/databoard/modal-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    @font-face {
        font-family: MaravaleExpanded;
        src: url("../../assets/fonts/digifaw.ttf"); //字体路径
    }

    .container {
        background-image: url("../../assets/images/databoard/bg.png");
        background-size: cover;
        background-repeat: no-repeat;
    }

    .title-wrap {
        background-image: url("../../assets/images/databoard/head-bg.png");
        background-repeat: no-repeat;
        background-position: top;
    }

    .count-wrap {
        height: 100%;
        background-image: url("../../assets/images/databoard/count-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .full-screen {
        background-image: url("../../assets/images/databoard/full-screen-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .statis-report {
        background-image: url("../../assets/images/databoard/full-screen-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .bg1 {
        background-image: url("../../assets/images/databoard/title-bg1.png");
    }
</style>

<style lang="scss">
    body {
        background-color: #000 !important;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .active {
        overflow-x: auto;
        overflow-y: auto;
    }
</style>
